import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ConnectionLostService {
  private sourceConnectionStatus = new BehaviorSubject<boolean>(true);
  connectionStatus = this.sourceConnectionStatus.asObservable();

  constructor() {}

  public checkConnectivityStatus() {
    fetch('https://www.google.com/generate_204', {
      method: 'HEAD',
      mode: 'no-cors',
      cache: 'no-cache',
    })
      .then(() => this.sourceConnectionStatus.next(true))
      .catch(() => this.sourceConnectionStatus.next(false));
  }
}
